import i18n from "@/i18n";
import { ProfileVue } from "fs-pb-vue2/vueModels/profile/ProfileVue";
import IPersonService from "fs-pb-vue2/services/person/IPersonService";
import { ReferenceData } from "fs-pb-vue2/data/referenceData";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import IOperationsHistoryService from "fs-pb-vue2/services/history/IOperationsHistoryService";
import { RequestParamsModel } from "fs-pb-vue2/models/statement/requestParamsModel";
import { RequestsStates } from "fs-pb-vue2/data/enums/requestsStates";
import IAuthService from "fs-pb-vue2/services/auth/IAuthService";
import { BaseLoginModel } from "fs-pb-vue2/models/auth/BaseLoginModel";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";

export class ProfileVueGB extends ProfileVue {

  /**Стор авторизации */
  get authService(): IAuthService<BaseLoginModel> {
    return container.get<IAuthService<BaseLoginModel>>(DiTokens.AuthService);
  }

  formatDate(d: Date): string {
    const monthA: any = i18n.t("common.genitiveMonths");
    return (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) +
      " " +
      monthA[d.getMonth()] +
      " " +
      d.getFullYear();
  }

  modalDetails: any = null;

  operationsList: any = null;

  operInfo: boolean = false;

  modalLoading: boolean = false;

  stateColor(stateText: string): string {
    let color: string = '';
    switch(stateText) {
      case i18n.t("main.operation.form.refExecuted").toString():
        color = '#00508F';
        break;
      case i18n.t("main.operation.form.refExecuting").toString():
        color = '#6F6F6F';
        break;
      default:
        color = '#FF0000';
        break;
    }
    return color;
  }

  stringRequestState(state: RequestsStates, desc: string): string {
    let stringState = "";
    switch (state) {
      case RequestsStates.Executed:
        stringState = i18n.t("main.operation.form.refExecuted").toString();
        break;
      case RequestsStates.Prepared:
      case RequestsStates.Preparing:
      case RequestsStates.Executing:
        stringState = i18n.t("main.operation.form.refExecuting").toString();
        break;
      case RequestsStates.PrepareError:
      case RequestsStates.ExecuteError:
      case RequestsStates.Denied:
        stringState = i18n
          .t("main.operation.form.refDenied", { errorText: desc })
          .toString();
        break;
      default:
        stringState = i18n.t("main.operation.form.refDenied").toString();
        break;
    }
    return stringState;
  }

  get historyService(): IOperationsHistoryService {
    return container.get<IOperationsHistoryService>(DiTokens.OperationsHistoryService);
  }

  async showOperInfoDialog(operation: any) {
    this.modalLoading = true;
    this.modalDetails = await this.historyService.getOperationDetails(
      operation
    );
    const doc: any = this.modalDetails.RequestData.DocumentFiles.length > 0 ? this.modalDetails.RequestData.DocumentFiles[0] : null;
    if (doc) {
      await OperationsApi.getDocumentFileData(doc.Id, doc.Name);
      this.modalLoading = false;
      return;
    }
    if (operation.sbpDetails) {
      this.modalDetails.sbpDetails = operation.sbpDetails;
    }
    try {
      let pict;
      if (!operation.Picture) {
        pict = require('./../../../public/img/default-oper.png');
      } else {
        pict = operation.Picture;
      }
    } catch(e) {
      console.log(e);
      this.modalLoading = false;
    }
    this.operInfo = true;
    this.modalLoading = false;
  }  

  async getOpeationsList() {

    this.modalLoading = true;

    const minDate: string = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().substr(0, 10);
    const maxDate: string = new Date().toISOString().substr(0, 10);

    const resObj = await this.historyService.getOperationsHistory(
      new RequestParamsModel({
        dateBegin: minDate,
        dateEnd: maxDate,
        contractId: '',
        searchText: '',
        sortType: 1,
        filter: 31,
        rootCatalog: null
      }), true
    );

    this.modalLoading = false;

    return resObj;
  }

  async callAction(action: () => Promise<void>) {
    await action();
  }
  
  async getReferences(): Promise<void> {
    this.modalLoading = true;
    await this.personStore.fetchRefrencesList(this.configStore.apiData.InquiriesFile);
    this.modalLoading = false;
  }

  /**Закрытие формыы */
  async destroyForm(): Promise<void> {
    this.$emit("hideSelf");
  }

  /** контент диалогового окна */
  dialogContent: any = {};

  referencesHref: string = 'orderReferences';

  get personService(): IPersonService {
    return container.get<IPersonService>(DiTokens.PersonService);
  }

  get PersonFIO():string {
    return this.personInfo.Data.Surname + ' ' + this.personInfo.Data.Name + ' ' + this.personInfo.Data.Patronymic || "ФИО"
  }
  get MobileTel():string {
    return this.personInfo.Data.MobileTel || "+7 (999) 999 99 99"
  }
  get RegAddress():string {
    return this.personInfo.Data.RegAddress || "Адрес регистрации"
  }
  get Inn():string {
    return this.personInfo.Data.Inn || "NNNNХХХХХХСС"
  }
  get EMail():string {
    return this.personInfo.Data.EMail || "xxx@x.x"
  }

  get referencesList(): Array<ReferenceData> {
    return this.personStore.referencesList;
  }
  
  get actions(): Array<any> {
    const actions: Array<any> = [];
    actions.push({
      /** Персональные данные */
      text: i18n.t("main.profile.personalData"),
      iconClass: "personal-data-icon",
      action: () => {
        this.dialogContent = new Object({
          vueName: "PersonalDataModal",
        });
        this.dialog = true;
      }
    });
    actions.push({
      /** Настройки входа */
      text: i18n.t("main.profile.loginSettings"),
      iconClass: "login-settings-icon",
      action: () => {
        this.dialogContent = new Object({
          vueName: "LoginSettingsModal",
        });
        this.dialog = true;
      }
    });
    actions.push({
      /** Переводы по номеру телефона */
      text: i18n.t("main.profile.transfersPhone"),
      iconClass: "transfers-phone-icon",
      action: () => {
        this.dialogContent = new Object({
          vueName: "TransfersPhoneModal",
        });
        this.dialog = true;
      }
    });
    actions.push({
      /** Лимиты */
      text: i18n.t("main.profile.limits"),
      iconClass: "limits-icon",
      action: () => {
        this.dialogContent = new Object({
          vueName: "CardLimitsModal",
          params: { 
            card: { Data: { Id: 0 } },
            cardRefId: 0,
            contract: { Data: { CurrencyCharCode: "RUR"}}
          }
        });
        this.dialog = true;
      }
    });
    actions.push({
      /** Документы */
      text: i18n.t("main.profile.documents"),
      iconClass: "references-icon",
      action: () => {
        this.dialogContent = new Object({
          vueName: "DocumentsModal",
          params: {}
        });
        this.dialog = true;
      }
    });
    actions.push({
      /** Справки */
      text: i18n.t("main.profile.references"),
      iconClass: "references-icon",
      action: () => {
        this.$router.push({ name: "References"})
      }
    });
    actions.push({
      /** Настройки приложения */
      text: i18n.t("main.profile.applicationSettings"),
      iconClass: "app-settings-icon",
      action: () => {
        this.dialogContent = new Object({
          vueName: "AppSettingsModal",
        });
        this.dialog = true;
      }
    });
    actions.push({
      /** История посещений */
      text: i18n.t("main.profile.visitHistory"),
      iconClass: "visit-history-icon",
      action: () => {
        this.$router.push("/authHistory");
      }
    });
    return actions;
  }

  /**Выход из системы */
  async logout() {
    await this.authService.logout();
  }

}